import React from 'react'

import { useAddressSearch, useResultsList } from '../hooks'

import Header from '../../common/components/Header'
import TextInput from '../../common/components/TextInput'

import SearchResult from './SearchResult'

import styles from './SearchPanel.module.css'

const SearchPanel = () => {
  const [query, { search, setQuery }] = useAddressSearch()
  const [{ resultIds, isLoading }] = useResultsList()

  return (
    <div className={styles.container}>
      <Header>
        Search {isLoading && <i className="fa fa-spinner fa-spin"></i>}
      </Header>
      <TextInput
        label="Address"
        placeholder="Enter Your Search"
        value={query}
        onChange={setQuery}
        button={{ icon: '', onClick: search }}
      />
      {resultIds &&
        (resultIds.length ? (
          <ul className={styles.list}>
            {resultIds.map((resultId, i) => (
              <SearchResult resultId={resultId} key={i} />
            ))}
          </ul>
        ) : (
          <div>No Results</div>
        ))}
    </div>
  )
}

export default SearchPanel
